import { useState } from 'react';
import { handleError } from '../../../../components/errors/errorHandling';
import { addSuccessToast } from '../../../../components/errors/toast/ToastUtils';
import {
  completeConnect as completeConnectService,
  revokeConnect as revokeConnectService,
} from '../../../../services/payment/PaymentService';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

interface Values {
  isLoading: boolean;
  completeConnect: (
    organizationId: string,
    code: string,
    name?: string,
    type?: string,
    status?: string,
  ) => Promise<void>;
  revokeConnect: (organizationId: string, accountId: string) => Promise<void>;
}

const useCompleteConnect = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const history = useHistory();
  const intl = useIntl();
  const completeConnect = async (organizationId: string, code: string, name = '', type = '', status = '') => {
    try {
      setIsLoading(true);
      await completeConnectService(organizationId, code, name, type, status);
      setIsLoading(false);
      addSuccessToast({ message: intl.formatMessage({ id: 'success.saved' }) });
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }

    history.replace(history.location.pathname, { path: history.location.pathname, search: '' });
  };

  const revokeConnect = async (organizationId: string, accountId: string) => {
    try {
      setIsLoading(true);
      await revokeConnectService(organizationId, accountId);
      setIsLoading(false);
      addSuccessToast({ message: intl.formatMessage({ id: 'success.saved' }) });
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }

    history.replace(history.location.pathname, { path: history.location.pathname, search: '' });
  };

  return { completeConnect, revokeConnect, isLoading };
};

export default useCompleteConnect;
